<template>
  <div>
    <!-- Botão Favoritos -->
    <vs-dropdown vs-trigger-click class="cursor-pointer">
      <div>
        <vs-button
          color="#CBEFFF"
          text-color="#0090CF"
          class="font-bold"
          icon="expand_more"
          icon-after
          >Favoritos
        </vs-button>
      </div>

      <vs-dropdown-menu>
        <vs-dropdown-item
          v-for="item in listFavoritos"
          :key="item.idRelatorioFavorito"
          @click="selecionaFavorito(item)"
        >
          <span style="text-wrap: nowrap">{{ item.nomeFavoritos }}</span>
        </vs-dropdown-item>
      </vs-dropdown-menu>
    </vs-dropdown>

    <!-- Modal Favoritos -->
    <Modal :active.sync="isModalOpen" title="Adicionar Favoritos">
      <div>
        <!-- Criar -->
        <div class="vx-row flex items-end gap-2 lg:gap-0 mb-3">
          <div class="vx-col w-full lg:w-3/4">
            <label class="vs-select--label">Nome do Favorito</label>
            <vs-input v-model="formFavorito.nome" class="w-full" />
          </div>
          <div class="vx-col w-full lg:w-1/4">
            <vs-button
              class="w-full"
              color="success"
              @click="salvaFavorito"
              :disabled="!formFavorito.nome"
              >Criar</vs-button
            >
          </div>
        </div>

        <!-- Lista -->
        <table class="table-auto w-full">
          <thead>
            <th class="text-center">Nome</th>
            <th class="text-center">Ação</th>
          </thead>
          <tbody class="text-center">
            <tr v-for="item in listFavoritos" :key="item.idRelatorioFavorito">
              <td>{{ item.nomeFavoritos }}</td>
              <td class="flex justify-center gap-2">
                <vs-tooltip text="Sobrescrever">
                  <vs-button
                    radius
                    color="warning"
                    icon="edit"
                    @click="sobrescreveFavorito(item.idRelatorioFavorito)"
                  />
                </vs-tooltip>
                <vs-tooltip text="Apagar">
                  <vs-button
                    radius
                    color="danger"
                    icon="delete"
                    @click="inativaFavorito(item.idRelatorioFavorito)"
                  />
                </vs-tooltip>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </Modal>
  </div>
</template>
<script>
import notify from '../../../../../utils/notify';
import service from '../../../../../services';
import Modal from '../../../../../components/Modal.vue';

export default {
  props: ['idEmpresa'],

  components: {
    Modal
  },

  data() {
    return {
      listFavoritos: [],
      filtroSelecionado: null,
      isModalOpen: false,
      formFavorito: {},
    };
  },

  methods: {
    abreModalFavoritos(value, obj) {
      this.isModalOpen = value;
      this.filtroSelecionado = obj;
    },

    selecionaFavorito(item) {
      this.$emit('favoritoSelecionado', item);
    },

    async salvaFavorito() {
      try {
        this.$vs.loading();
        const objSend = { ...this.filtroSelecionado, ...this.formFavorito };

        await service.post('Dinamicos', 'AdicionarFavoritos', objSend);
        notify.notifySuccess(this.$vs, 'Favorito salvo com sucesso.');
        this.buscaFavoritos();
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.isModalOpen = false;
        this.$vs.loading.close();
      }
    },

    async buscaFavoritos() {
      try {
        this.$vs.loading();
        this.listFavoritos = [];
        const result = await service.getAll(
          'Dinamicos',
          {},
          `listFavoritos/${this.idEmpresa}`,
        );
        result.data.forEach((item) => {
          item.filtro = JSON.parse(item.filtro);
          this.listFavoritos.push(item);
        });
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },

    async sobrescreveFavorito(idRelatorioFavorito) {
      try {
        this.$vs.loading();
        const objSend = {
          ...this.filtroSelecionado,
          idRelatorioFavorito: idRelatorioFavorito,
        };
        await service.post('Dinamicos', 'SobrescreverFavoritos', objSend);
        notify.notifySuccess(this.$vs, 'Favorito sobrescrito com sucesso.');
        this.buscaFavoritos();
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.isModalOpen = false;
        this.$vs.loading.close();
      }
    },

    async inativaFavorito(idRelatorioFavorito) {
      try {
        this.$vs.loading();

        const objSend = {
          idRelatorioFavorito,
        };
        await service.post('Dinamicos', 'InativaFavorito', objSend);
        this.isModalOpen = false;
        notify.notifySuccess(this.$vs, 'Favorito apagado com sucesso.');
        this.buscaFavoritos();
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
  },

  mounted() {
    this.buscaFavoritos();
  },
};
</script>
